import apiClient from './apiClient';

const mapCategory = (category) => {
  if (!category) return null;
  return {
    id: String(category.id),
    name: category.name,
    slug: category.slug,
    parentId: category.parent_id != null ? String(category.parent_id) : null,
    description: category.description || '',
    image: category.image_url || '',
    order: category.order ?? 0,
    isActive: category.is_active ?? true,
    children: (category.children || []).map(mapCategory),
  };
};

export const flattenCategories = (categories) => {
  const result = [];
  const walk = (list) => {
    if (!list?.length) return;
    list.forEach((item) => {
      result.push(item);
      walk(item.children);
    });
  };
  walk(categories);
  return result;
};

/**
 * Get all categories
 * @returns {Promise<Array>} Array of categories
 */
export const getCategories = async () => {
  try {
    const response = await apiClient.get('/categories');
    return response.data.map(mapCategory);
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

/**
 * Get a single category by ID
 * @param {string} categoryId - Category ID
 * @returns {Promise<Object>} Category object
 */
export const getCategoryById = async (categoryId) => {
  try {
    const response = await apiClient.get(`/categories/${categoryId}`);
    return mapCategory(response.data);
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error;
  }
};

/**
 * Get category by slug
 * @param {string} slug - Category slug
 * @returns {Promise<Object|null>} Category object or null
 */
export const getCategoryBySlug = async (slug) => {
  try {
    const response = await apiClient.get(`/categories/slug/${slug}`);
    return mapCategory(response.data);
  } catch (error) {
    console.error('Error fetching category by slug:', error);
    throw error;
  }
};
